import { MatrixProduct } from './matrix-product.model';
import { Fabric } from './product-fabric.model';
import { ProductGroup } from './product-group.model';
import type { ProductsSizeGroupsModel } from './products-size-groups.model';
import { ProductsSizes } from './products-sizes.model';

export class ProductsMatrix {
  public warehouse?: string;
  public products: MatrixProduct[];
  public productGroups: ProductGroup[];
  public fabrics: Fabric[];
  public sizes: ProductsSizes[];
  public sizeGroups: ProductsSizeGroupsModel[];
}
